import React, { useEffect, useState } from "react";
import { BasicSnapshot } from "../../global/components/snapshots/BasicSnapshot";
import { snapshotImage, StreamType } from "../../hoc/snapshotImage";

const SnapshotComponent = ({
  editFlow,
  fovObj,
  selectedCameraQR,
  companionSelected,
  imageSize,
  initialPolygons,
  originalSize,
  component,
  handleChange,
  width,
  height,
  refreshImage,
  title,
  setRefreshButtonClicked,
  belowImageSlot,
  onRefetchReady
}) => {
  const [SnapshotImg, setSnapshotImg] = useState(null);
  useEffect(() => {
    if (editFlow) {
      let newSnap;
      newSnap = snapshotImage(
        component ? component : BasicSnapshot,
        fovObj.fovId || fovObj?.FOVId,
        selectedCameraQR,
        StreamType.PAIRED_CAMERA,
        companionSelected?.qrcode || companionSelected,
        handleChange
      );
      setSnapshotImg(() => newSnap);
    } else {
      let newSnap;
      newSnap = snapshotImage(
        component ? component : BasicSnapshot,
        fovObj.fovId,
        selectedCameraQR,
        StreamType.UNPAIRED_CAMERA,
        companionSelected?.id,
        handleChange
      );
      setSnapshotImg(() => newSnap);
    }
  }, []);

  return (
    <>
      {SnapshotImg ? (
        <SnapshotImg
          imageSize={imageSize}
          initialPolygons={initialPolygons}
          originalSize={originalSize}
          width={width}
          height={height}
          refreshImage={refreshImage}
          title={title}
          setRefreshButtonClicked={setRefreshButtonClicked}
          belowImageSlot={belowImageSlot}
          onRefetchReady={onRefetchReady}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default SnapshotComponent;
